<template>
    <transition-group tag="div" name="slide-fade">
        <div v-for="(round,index) in rounds" :key="'index'+index">
            <span class="round_number"><a :id="'round_'+index"></a></span>
            <table class="round_table">
                <tr class="thTop">
                    <th class="date">Round {{index}}</th>
                    <th class="time">Time</th>
                    <th class="rink">Rink</th>
                    <th class="team"></th>
                    <th class="score" :colspan="special == 1 ? 3 : 1">Score</th>
                    <th class="score" :colspan="special == 1 ? 3 : 1">Score</th>
                    <th class="team"></th>
                </tr>
                <tr v-for="match in round" :class="{ dateChange: match.dateChange == 1}">
                    <td class="date">{{match.date}}</td>
                    <td class="time">{{match.time}}</td>
                    <td class="rink">{{match.rink}}</td>
                    <td class="team">{{match.team1}}</td>
                    <template v-if="special==0">
                    <td class="score score_td1">{{match.score1}}</td>
                    <td class="score score_td2">{{match.score2}}</td>
                    </template>
                    <template v-else>
                        <td class="score score_td1_1">{{match.score1_1}}</td>
                        <td class="score score_td1_2">{{match.score1_2}}</td>
                        <td class="score score_td1_3">{{match.score1_3}}</td>
                        <td class="score score_td2_1">{{match.score2_1}}</td>
                        <td class="score score_td2_2">{{match.score2_2}}</td>
                        <td class="score score_td2_3">{{match.score2_3}}</td>
                    </template>
                    <td class="team">{{match.team2}}</td>
                </tr>
            </table>
        </div>
    </transition-group>
</template>
<script>
    export default{
        props:['rounds', 'special']
    }
</script>


// WEBPACK FOOTER //
// src/components/Leagues/Rounds.vue